import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload } from '@fortawesome/free-solid-svg-icons';

const InputFile = ({ attr, handleUploadedFile }) => {
    const [fileName, setFileName] = useState('');
    const [fileData, setFileData] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setFileName(file.name);
        setFileData(file);

        // Pass to parent
        handleUploadedFile(file);
    };

    return (
        <div className="flex-1 my-3 px-2">
            <label htmlFor={attr.name} className="block text-gray-700 text-sm font-bold mb-2">
                {attr.placeholder}
            </label>

            <div className="mb-4 mt-2 flex items-center gap-4">
                <FontAwesomeIcon icon={faFileUpload} size="2x" />
                <span className="text-sm text-gray-700">
                    {fileName ? fileName : 'Belum ada berkas dipilih'}
                </span>
            </div>

            <input
                style={{ display: 'none' }}
                type="file"
                id={attr.name}
                accept={attr.accept || '*'}
                onChange={handleFileChange}
            />

            <label
                htmlFor={attr.name}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded cursor-pointer text-sm inline-block"
            >
                Pilih Berkas
            </label>
        </div>
    );
};

export default InputFile;
